<template>
  <div v-loading="loading">
    <widget-news-list ref="WidgetNews" @refresh="RefreshClick" />
  </div>
</template>

<script>
import { getWeiBoNews } from "@/api/news.js";
import WidgetNewsList from "@/components/Widgets/WidgetNewsList.vue";
export default {
  components: {
    WidgetNewsList,
  },
  data() {
    return {
      loading: false,
      Query: {
        skey: "",
        startYmd: "",
        endYmd: "",
        pageIndex: 1,
        pageSize: 20,
      },
      WeiBoInfos: [],
    };
  },
  created() {},
  methods: {
    GetWeiBoInfos(query) {
      this.loading = true;
      if (query) {
        Object.assign(this.Query, query);
      }
      getWeiBoNews(
        this.Query.skey,
        this.Query.startYmd,
        this.Query.endYmd,
        this.Query.pageIndex,
        this.Query.pageSize
      ).then((res) => {
        if (res.code == 0) {
          this.WeiBoInfos = res.data.newsList;
          this.$refs.WidgetNews.SetData(this.WeiBoInfos, "微博", "weibo.png", "#4a1a2c");
        } else {
          this.$message.error(res.data.msg);
        }
        this.loading = false;
      });
    },
    RefreshClick() {
      const getCurrentDate = () => {
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}${month}${day}`;
      };

      const currentDate = getCurrentDate();
      this.Query.startYmd = currentDate;
      this.Query.endYmd = currentDate;

      this.GetWeiBoInfos(this.Query);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>